<template>
  <article class="rounded-[20px] overflow-hidden shadow-md flex flex-col" data-component="CardEventMedia">
    <template v-if="image">
      <MoleculePicture v-if="image" :image="image" :lazy="false" />
    </template>
    <template v-else-if="video">
      <MoleculeCarouselVideo :url="video" />
    </template>
    <div v-if="caption" class="px-6 py-3 text-xs p-10 w-full md:text-base" v-html="caption" />
  </article>
</template>

<script setup lang="ts">
defineProps({
  image: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  video: { type: String, required: false, default: undefined },
  caption: { type: String, required: false, default: undefined },
})
</script>
